<template>
  <div>
    <vue-headful title="Credimóvil | Crear cuenta" />
    <menu-component v-bind:use-create-account="true"></menu-component>

    <!-- Banner Area -->
    <section class="banner_area banner_area_9">
      <div class="container">
        <h2>Crear cuenta</h2>
        <ol class="breadcrumb">
          <li></li>
          <li></li>
        </ol>
      </div>
    </section>
    <!-- Banner Area -->

    <!-- Easy cash Area -->
    <section class="easy_cash_area cot-credict crear-cuenta-form">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 back-form">
            <form class="from_main" action="php/contact.php" method="post" id="phpcontactform" novalidate="novalidate">
              <div class="row">
                <div class="col-lg-6 select_from">
                  <h6>Celular*</h6>
                  <input type="tel" class="post_select" id="phone" name="phone" v-model="phone" v-only-numbers
                    @blur=" $v.phone.$touch(); phone = $event.target.value.trim().replace(/\s/g, '')"
                    :class="{ 'error': $v.phone.$dirty && $v.phone.$invalid }">
                </div>
                <div class="col-lg-6 select_from">
                  <h6>Correo electrónico*</h6>
                  <input type="email" class="post_select" id="email" name="email" v-model="email"
                    @blur=" $v.email.$touch()" :class="{ 'error': $v.email.$dirty && $v.email.$invalid }">
                </div>
                <div class="col-lg-6 select_from">
                  <h6>Contraseña*</h6>
                  <input type="password" class="post_select" minlength="12" id="password" name="password"
                    v-model="password" @blur=" $v.password.$touch()"
                    :class="{ 'error': $v.password.$dirty && $v.password.$invalid }">
                  <small :class="{ 'text-danger': $v.password.$dirty && $v.password.$invalid }">
                    La contraseña deberá contar con al menos 8 caracteres de los cuales es obligatorio incluir una
                    mayúscula y un número.
                  </small>
                </div>
                <div class="col-lg-6 select_from">
                  <h6>Confirmar contraseña*</h6>
                  <input type="password" class="post_select mb-5" minlength="12" id="conf-password" name="conf-password"
                    v-model="confPassword" @blur=" $v.confPassword.$touch()"
                    :class="{ 'error': $v.confPassword.$dirty && $v.confPassword.$invalid }">

                </div>
                <div class="col-12 select_from">
                  <input type="checkbox" name="condiciones" id="confirmation" v-model="confirmation" />
                  <span for="condiciones">Estoy de acuerdo con el <a href="/privacy-notice">Aviso de privacidad</a></span>
                </div>
                <div class="form-group col-12">
                  <button class="theme_btn btn float-right" id="btn-send" v-on:click="register()">Crear cuenta</button>
                  <div id="js-contact-result" data-success-msg="Form submitted successfully."
                    data-error-msg="Messages Successfully"></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
    <!-- End Easy cash Area -->
  </div>
</template>

<script>
import { required, minLength, between, maxValue, minValue, email } from 'vuelidate/lib/validators';

var regexEmail = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
var regexPass = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}/;

export default {
  name: 'CreateAccount',
  data() {
    return {
      id_quote_credit: null,
      confirmation: false,
      email: '',
      password: '',
      confPassword: '',
      phone: '',
    }
  },
  validations() {
    return {
      email: { required, validateEmail: (value) => { return regexEmail.test(value); } },
      password: { required, minLength: minLength(8), validatePass: (value) => { return regexPass.test(value); } },
      confPassword: { required, minLength: minLength(8) },
      phone: { required },
    }
  },
  methods: {
    register() {
      event.preventDefault();
      if (this.password.length < 8)
        this.$swal("CUIDADO!", "El campo de contraseña tiene que ser de 8 o más caracteres", "info");
      else if (this.password != this.confPassword)
        this.$swal("CUIDADO!", "El campo de contraseña y confirmar contraseña no coinciden", "info");
      else if (this.confirmation != true)
        this.$swal("CUIDADO!", "Por favor acepte el aviso de privacidad", "info");
      else {
        const data = {
          email: this.email,
          password: this.password,
          phone: this.phone,
        };

        this.$SessionService.register(data).then((result) => {
          localStorage.setItem('session', result.data.session);
          localStorage.setItem('id', result.data.id);
          if (this.id_quote_credit !== null) {
            const update = {
              id: parseInt(this.id_quote_credit),
              user_id: parseInt(result.data.id)
            }
            this.$UserService.updateCreditQuotation({ data: update })
              .then((result) => {window.location.reload();},
              (err) => this.$swal("CUIDADO!", (err.msg), "error"));
          } else {
            window.location = '/quotation';
          }

        }, (err) => this.$swal("CUIDADO!", (err.msg), "error"));
      }
    },
    start() {
      this.id_quote_credit = localStorage.getItem('quote_credit');
    },
  },
  created() {
    this.start();
  }
}
</script>

<style lang="scss">
.error {
  border-color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/views/CreateAccount.vue